import styled, { css } from 'styled-components';
import { BtnType } from '.';
import { ifProp, theme, palette } from 'styled-tools';
import CheckOnArrow from 'assets/img/common/ic_check_arrow_blue.svg';

interface Props {
    btnType?: BtnType;
    checked?: boolean;
    radius?: number;
    height?: number;
    width?: number;
}

export const BtnRadioContainer = styled.div<Props>`
    position: relative;
    display: flex;
    align-items: center;    
    border: 1px solid ${ifProp('checked', palette('blue_900'), palette('gray_opacity_200'))};
    background-color:${ifProp('checked', palette('blue_opacity_100'), palette('gray_opacity_50'))};
    border-radius: ${props => props.radius ? props.radius : '4'}px;
    height: ${props => props.height ? props.height : '44'}px;
    width: ${props => props.width ? css`${props.width}px` : '100%'};


    ${props => {
        return css`
        ${BtnRadioLabel} {
            color: ${props.checked ? palette('blue_900') : palette('gray_opacity_600')}
        }
        `;
    }}
    
    ${props => {
        if (props.btnType === 'SUBSCRIPTION') {
            return css`
                justify-content: flex-start;
            `;
        } else {
            return css`
                justify-content: center;
                ${props.checked ? css`
                    &::before{    
                        content: '';
                        position: absolute;
                        margin-left: -24px;
                        width: 20px;
                        height: 20px;
                        background-image: url(${CheckOnArrow});
                        background-size: 14px 20px;
                        background-repeat: no-repeat;
                        cursor: pointer;
                    }
                ` : null}
            `;
        }
    }}
`;

export const BtnRadio = styled.input`
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    margin: 0;
`;

export const LabelWrapper = styled.div`
    display: flex;
    align-items: center;
    
`;

export const CheckIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    margin-left: 20px;
    margin-right: 12px;
`;

export const BtnRadioLabel = styled.label`
    ${theme('fontStyle.body2')}
    
`;

